export default __webpack_public_path__ + "static/media/Kattlas Vellikada.f68b6b92.jpg";